import React from 'react';
import Slider from 'react-slick';
import './Structure.css';

const Structure = ({ members }) => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 800, // Fluidité accrue
        slidesToShow: 3, // Affiche 3 cartes à la fois
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500, // Défilement automatique
        pauseOnHover: false, // Ne pas arrêter au survol
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };


    return (
        <section className="structure-section" data-aos="fade-up">
            <h2 className="section-club-title">Structure du Club</h2>
            <p className="section-legend">
                Découvrez les membres clés qui structurent notre club et permettent son bon fonctionnement.
            </p>
            <div className="structure-carousel">
                <Slider {...settings}>
                    {members.map((member, index) => (
                        <div key={index} className="structure-card">
                            <div className="structure-initials">
                                {`${member.in_prenom[0]}${member.in_nom[0]}`}
                            </div>
                            <div className="structure-details">
                                <h3 className="structure-name">{`${member.in_prenom} ${member.in_nom}`}</h3>
                                <p className="structure-role">{member.ti_lib}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default Structure;
